import angular from 'angular';
import emailCcField from './emailCcField';
import './style.scss';

export default angular
  .module('emailCcField', [])
  .component('emailCcField', emailCcField).name;
